export function findNodeByUid(
    node: EntityDetails | null | undefined,
    uid: string
): EntityDetails | null {
    try {
        if (!node || !uid) return null;
        if (node.uid === uid) return node;
        if (Array.isArray(node.subRows)) {
            for (const sub of node.subRows) {
                const found = findNodeByUid(sub, uid);
                if (found) return found;
            }
        }
        return null;
    } catch (error) {
        console.error("findNodeByUid failed", error);
        return null;
    }
}

export function collectCountries(
    node: EntityDetails | null | undefined,
    acc: string[] = []
): string[] {
    try {
        if (!node) return acc;
        if (typeof node.Country === "string" && node.Country) {
            acc.push(node.Country);
        }
        if (Array.isArray(node.subRows)) {
            for (const sub of node.subRows) {
                collectCountries(sub, acc);
            }
        }
        return acc;
    } catch (error) {
        console.error("collectCountries failed", error);
        return acc;
    }
}

export function uniqueNonEmpty(values: ReadonlyArray<string>): string[] {
    try {
        return [...new Set(values.filter((v): v is string => Boolean(v)))];
    } catch (error) {
        console.error("uniqueNonEmpty failed", error);
        return [];
    }
}

export function getCommercialName(
    node: EntityDetails | null | undefined,
    translatedKey: string
): string {
    try {
        if (!node) return "";
        const translated = node[translatedKey];
        if (typeof translated === "string" && translated) return translated;
        const fallback = node["Nom commercial"];
        return typeof fallback === "string" ? fallback : "";
    } catch (error) {
        console.error("getCommercialName failed", error);
        return "";
    }
}
